import {authProvider, baseAPIURL} from "./utils/authProvider";
import { fetchUtils } from 'react-admin';

export const getRequestOptions = () => {
  return {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authProvider.getAccountInfo()?.jwtIdToken }
  }
};

export const headers = () => {
  return {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authProvider.getAccountInfo()?.jwtIdToken}
}

export const checkAccess = () => {
  return fetch(baseAPIURL + 'users/roles', getRequestOptions())
    .then(response => {
      return response.json()
    })
    .then(result => {
      for (let i = 0; i < result.length; i++) {
        if (result[i] === 'Admin') {
          return true
        }
      }
      return false
    })
    .catch(e => {
      console.log(e);
      return false
    });
}

export const getSizeOptions = () => {
  return fetch(baseAPIURL + 'vm/sizes', getRequestOptions())
    .then(response => {
      return response.json()
    })
    .then(result => {
      // console.log(result)
      return result.map((el: string) => {return {name: el}})
    })
    .catch(e => {
      console.log(e);
      return []
    });
}

export const stopSessions = (selectedIds: number[]) => {
  console.log("stopMany")

  selectedIds.forEach((id) => {
      fetch(`${baseAPIURL}VM/stop/${id}`, {
        method: 'POST',
        headers: headers(),
      })
        .then(() => {
          console.log("stopOne: " + id)
        })
        .catch(e => {
          console.log(e);
        });
  })
}

export const testHttpClient = () => {
  return fetchUtils.fetchJson(baseAPIURL, getRequestOptions());
}